import { render } from "./Access.vue?vue&type=template&id=7e9b9abf"
const script = {}

import exportComponent from "/var/www/amee/gdaudit-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__